/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Peruuta',
    CONFIRM: 'Vahvista',
    CONFIRM_POLL_RESPONSE: 'Vahvista vastaus',
    CONTINUE: 'Jatka',
    COPY: 'Kopioi',
    DELETE: 'Poista',
    DELETE_MESSAGE: 'Poista viesti',
    EDIT: 'Muokkaa',
    FINISH: 'Viimeistele',
    HIDE_ANSWERS: 'Piilota vastaukset',
    LETS_GET_STARTED: 'Tietenkin, aloitetaanpa.',
    MARK_AS_UNREAD: 'Merkitse lukemattomaksi',
    REPLY: 'Vastaa',
    SEE_ANSWERS: 'Katso vastaukset',
    START_SURVEY: 'Aloita kysely'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'Tiedoston enimmäiskoko on {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Kysely on vanhentunut, koska tälle kategoriolle on jo kampanja.',
    ERROR_CREATING_NEW_SUGGESTION: 'Virhe uuden tarjouksen luomisessa',
    ERROR_SAVING_PRODUCT_REVIEW: 'Virhe tallennettaessa tuotearvostelua',
    ERROR_SENDING_MESSAGE: 'Virhe viestin lähettämisessä',
    ERROR_SUBMITTING_SURVEY: 'Virhe kyselyn lähettämisessä',
    IMAGE_SIZE_EXCEEDED: 'Kuvan enimmäiskoko on {size}MB.',
    MESSAGE_ALREADY_READ:
      'Tätä viestiä ei voi enää muokata, koska se on jo luettu.',
    UPLOADED_ASSETS_EXCEED: 'Tiedostojen enimmäismäärä on {limit}',
    VIDEO_SIZE_EXCEEDED: 'Videon enimmäiskoko on {size}MB.'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Toimet',
    ADDITIONAL_COMMENTS_QUESTION: 'Lisäkommentti?',
    ANSWERED_ON: 'Vastattu {date}',
    CONTACT_OWNER: 'Jotain meni pieleen. Ota yhteyttä esimieheesi',
    CREATE_NEW_CAMPAIGN_SUGGESTION:
      'Napsauta tästä luodaksesi uuden tarjouksen',
    EDITED: 'Muokattu',
    EXPIRED_ON: 'Vanhentunut {date}',
    LAST_READ: 'Viimeksi luettu',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Tarjous vanhentunut',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Hyväksymällä kampanja luodaan ja se alkaa huomenna.\nSaat myös huomenna viestin julisteen kanssa jaettavaksi.\nTämä tarjous on saatavilla 3 päivän ajan.',
    QUANTITY: 'Määrä',
    REACT: 'React',
    REACTIONS: 'Reaktiot',
    RESPOND_BY: 'Vastaa viimeistään {date}',
    SEE_PRODUCTS: 'Katso tuotteet',
    SEEN: 'Seen',
    SELECT_ADDRESS: 'Valitse osoite',
    SELECT_ONE_OPTION: 'Valitse vaihtoehto',
    SELECT_ONE_OR_MORE_OPTION: 'Valitse yksi tai useampi vaihtoehto',
    SENT: 'Lähetetty',
    SWIPE_TO_CANCEL: 'Peruuta pyyhkäisemällä',
    TYPE_NEW_MESSAGE: 'Kirjoita uusi viesti',
    VOICE_MESSAGE: 'Ääniviesti'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Tämä toiminto vahvistaa tilauksen, eikä vastausta voi muuttaa. Haluatko varmasti jatkaa?',
    DELETE_MESSAGE_CONFIRM: 'Haluatko varmasti poistaa tämän viestin?',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Voitko antaa meille mielipiteesi tästä tuotteesta?',
    MESSAGE_DELETED: 'Tämä viesti on poistettu'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
